var Aneox;
(function (Aneox) {
  (function (Sequences) {
    'use strict';

    var Contact = (function () {

      var self;
      var animations;
      var timeline;

      var hasPlayedThroughAnimation = {};

      function Contact(anims) {
        self = this;
        animations = anims;
        
        timeline = new TimelineMax({ paused: true });

        timeline
        .add(new animations.OpeningTimeline($('#contact-opening')))
        .addPause();
      }

      Contact.prototype.mastEnterAnimation = function() {
        timeline.play();
      };

      Contact.prototype.handleWindowResize = function(bodyWidth, bodyHeight) {

      };

      Contact.prototype.resetAnimations = function() {
        timeline.pause().progress(0);
      }


      return Contact;
    })();

    Sequences.Contact = Contact;
  })(Aneox.Sequences || (Aneox.Sequences = {}));
})(Aneox || (Aneox = {}));